import {
  Injectable
} from '@angular/core';

import {
  Observable
} from 'rxjs';

import {
  ApiService
} from '../core/api.service';

export interface SubscriptionPlan {
  id: number;
  code: string;
  name: string;
  description?: string | null;
  price: number | string;
  trialDays: number;
  isActive: boolean;
  mercadoPagoPlanId?: string | null;
}

export type SubscriptionStatus =
  | 'TRIAL'
  | 'PENDING'
  | 'ACTIVE'
  | 'PAST_DUE'
  | 'PAUSED'
  | 'CANCELED'
  | 'EXPIRED';

export type SubscriptionPaymentStatus =
  | 'PENDING'
  | 'APPROVED'
  | 'REJECTED'
  | 'CANCELED'
  | 'REFUNDED'
  | 'CHARGED_BACK';

export interface SubscriptionPayment {
  id: number;
  subscriptionId: number;
  providerPaymentId: string;

  status:
    SubscriptionPaymentStatus;

  amount: number | string;
  currency: string;

  paymentMethod?: string | null;
  statusDetail?: string | null;

  paidAt?: string | null;
  approvedAt?: string | null;
  rejectedAt?: string | null;
  refundedAt?: string | null;

  periodStart?: string | null;
  periodEnd?: string | null;

  createdAt: string;
  updatedAt: string;
}

export interface RestaurantSubscription {
  id: number;
  restaurantId: number;
  planId: number;

  status:
    SubscriptionStatus;

  externalReference: string;

  trialStartedAt: string;
  trialEndsAt: string;

  currentPeriodStart?: string | null;
  currentPeriodEnd?: string | null;
  nextBillingAt?: string | null;

  activatedAt?: string | null;
  pastDueAt?: string | null;
  suspendedAt?: string | null;
  canceledAt?: string | null;
  expiredAt?: string | null;

  mercadoPagoPlanId?: string | null;

  mercadoPagoSubscriptionId?:
    string | null;

  mercadoPagoPayerId?:
    string | null;

  plan: SubscriptionPlan;

  payments?: SubscriptionPayment[];
}

export interface SubscriptionDetailsResponse {
  subscription:
    RestaurantSubscription | null;

  hasAccess: boolean;
  trialDaysRemaining: number;
}

export interface AuthorizeSubscriptionPayload {
  cardTokenId: string;
  payerEmail: string;
}

export interface AuthorizeSubscriptionResponse {
  message: string;

  subscription:
    RestaurantSubscription;

  mercadoPago: {
    id: string;
    status: string;
    nextPaymentDate?: string | null;
    initPoint?: string | null;
  };
}

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(
    private readonly api:
      ApiService
  ) {}

  getSubscription(
    restaurantId: number
  ): Observable<
    SubscriptionDetailsResponse
  > {
    return this.api.get<
      SubscriptionDetailsResponse
    >(
      `/restaurants/${restaurantId}/subscription`
    );
  }

  authorizeSubscription(
    restaurantId: number,
    payload:
      AuthorizeSubscriptionPayload
  ): Observable<
    AuthorizeSubscriptionResponse
  > {
    return this.api.post<
      AuthorizeSubscriptionResponse
    >(
      `/restaurants/${restaurantId}/subscription/authorize`,
      payload
    );
  }
}